import ExecutePopupCorrectTick from './ExecutePopupCorrectTick';

export default ExecutePopupCorrectTick;
